import { createFrontendModule } from '@backstage/frontend-plugin-api';
import techdocsFrontendPlugin from '@backstage/plugin-techdocs/alpha';
import { copyMarkdownAddon } from '../../components/techdocs/CopyMarkdownAddon';
import { TechDocsIndexContent } from '../../components/techdocs/TechDocsIndexContent';
import { PersistedUserListFilterPage } from '../../components/userListFilter/persistedUserListFilter';

// PAT-1024: `/docs` and the reader come from `@backstage/plugin-techdocs/alpha`
// (listed in `features` in App.tsx). This module adjusts that plugin:
//
// - `page:techdocs` (the index) keeps the user-list filter the user last picked
//   on the catalog, API docs or docs pages. Upstream only reads `initialFilter`
//   from static config, so its loader is replaced with one that re-reads the
//   persisted filter on every mount, as the legacy `/docs` route did. The page
//   keeps its path, route ref and the title set in app-config.yaml; the
//   upstream `initialFilter` config no longer has any effect.
// - `addon:techdocs/copy-markdown` adds the Copy Markdown button to the reader.
//   ReportIssue and Mermaid come from their own `/alpha` modules (App.tsx).
//
// The entity page's Docs tab is still legacy (`EntityTechdocsContent` with JSX
// `<TechDocsAddons>` in EntityPage.tsx) until PAT-1028, so an addon change must
// be made there too.
export const techdocsIndexPage = techdocsFrontendPlugin
  .getExtension('page:techdocs')
  .override({
    params: {
      loader: async () => (
        <PersistedUserListFilterPage
          propName="initialFilter"
          defaultFilter="owned"
        >
          <TechDocsIndexContent />
        </PersistedUserListFilterPage>
      ),
    },
  });

export const techdocsModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [techdocsIndexPage, copyMarkdownAddon],
});
